/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {Limit} from '../models/Limit';

export interface GetDefaultUserCommonLimits$Request {
    userId: number;
}

export interface GetDefaultUserCommonLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDefaultUserCommonLimitsRequest = createAction<PayloadData<void, GetDefaultUserCommonLimits$Request>>('DEFAULT_USER_LIMITS__GET_DEFAULT_USER_COMMON_LIMITS__REQUEST');
export const getDefaultUserCommonLimitsSuccess = createAction<PayloadData<Array<Limit>, GetDefaultUserCommonLimits$Request>>('DEFAULT_USER_LIMITS__GET_DEFAULT_USER_COMMON_LIMITS__SUCCESS');
export const getDefaultUserCommonLimitsFailure = createAction<PayloadData<Error, GetDefaultUserCommonLimits$Request, true>>('DEFAULT_USER_LIMITS__GET_DEFAULT_USER_COMMON_LIMITS__FAILURE');

export const getDefaultUserCommonLimitsActions = [
    getDefaultUserCommonLimitsRequest,
    getDefaultUserCommonLimitsSuccess,
    getDefaultUserCommonLimitsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDefaultUserCommonLimits = (meta: GetDefaultUserCommonLimits$Request, config?: GetDefaultUserCommonLimits$Config) => {
    return {
        CALL_API: {
            types: getDefaultUserCommonLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/default/common-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDefaultUserMcpLimits$Request {
    userId: number;
}

export interface GetDefaultUserMcpLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDefaultUserMcpLimitsRequest = createAction<PayloadData<void, GetDefaultUserMcpLimits$Request>>('DEFAULT_USER_LIMITS__GET_DEFAULT_USER_MCP_LIMITS__REQUEST');
export const getDefaultUserMcpLimitsSuccess = createAction<PayloadData<Array<Limit>, GetDefaultUserMcpLimits$Request>>('DEFAULT_USER_LIMITS__GET_DEFAULT_USER_MCP_LIMITS__SUCCESS');
export const getDefaultUserMcpLimitsFailure = createAction<PayloadData<Error, GetDefaultUserMcpLimits$Request, true>>('DEFAULT_USER_LIMITS__GET_DEFAULT_USER_MCP_LIMITS__FAILURE');

export const getDefaultUserMcpLimitsActions = [
    getDefaultUserMcpLimitsRequest,
    getDefaultUserMcpLimitsSuccess,
    getDefaultUserMcpLimitsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDefaultUserMcpLimits = (meta: GetDefaultUserMcpLimits$Request, config?: GetDefaultUserMcpLimits$Config) => {
    return {
        CALL_API: {
            types: getDefaultUserMcpLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/default/mcp-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetDefaultUserSearchLimits$Request {
    userId: number;
}

export interface GetDefaultUserSearchLimits$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDefaultUserSearchLimitsRequest = createAction<PayloadData<void, GetDefaultUserSearchLimits$Request>>('DEFAULT_USER_LIMITS__GET_DEFAULT_USER_SEARCH_LIMITS__REQUEST');
export const getDefaultUserSearchLimitsSuccess = createAction<PayloadData<Array<Limit>, GetDefaultUserSearchLimits$Request>>('DEFAULT_USER_LIMITS__GET_DEFAULT_USER_SEARCH_LIMITS__SUCCESS');
export const getDefaultUserSearchLimitsFailure = createAction<PayloadData<Error, GetDefaultUserSearchLimits$Request, true>>('DEFAULT_USER_LIMITS__GET_DEFAULT_USER_SEARCH_LIMITS__FAILURE');

export const getDefaultUserSearchLimitsActions = [
    getDefaultUserSearchLimitsRequest,
    getDefaultUserSearchLimitsSuccess,
    getDefaultUserSearchLimitsFailure
] as const;

/**
 * @param {number} meta.userId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDefaultUserSearchLimits = (meta: GetDefaultUserSearchLimits$Request, config?: GetDefaultUserSearchLimits$Config) => {
    return {
        CALL_API: {
            types: getDefaultUserSearchLimitsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/users/${meta.userId}/default/searches-limits`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

